<template>
  <div class="bonusDashboard h100">
    <!-- <h1>This is an bonusDashboard page</h1> -->
    <el-card>
      <el-tabs class="menu-tabs" type="card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="岗位发放系数" name="1">
          <positionCoefficient ref="positionCoefficientRef"></positionCoefficient>
        </el-tab-pane>
        <el-tab-pane label="岗位KPI达成统计" name="2">
          <positionKpiAch ref="positionKpiAchRef"></positionKpiAch>
        </el-tab-pane>
        <el-tab-pane label="岗位计划系数与发放系数对比" name="3">
          <positionCoefficientComparison ref="positionCoefficientComparisonRef"></positionCoefficientComparison>
        </el-tab-pane>
        <el-tab-pane label="岗位达成与发放" name="4">
          <positionAch ref="positionAchRef"></positionAch>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import positionCoefficient from './positionCoefficient.vue'
import positionKpiAch from './positionKpiAch.vue'
import positionCoefficientComparison from './positionCoefficientComparison.vue'
import positionAch from './positionAch.vue'
export default {
  name: 'bonusDashboard',
  components: {
    positionCoefficient,
    positionKpiAch,
    positionCoefficientComparison,
    positionAch
  },
  data () {
    return {
      activeName: '1'
    }
  },
  created () {},
  mounted () {},
  methods: {
    // tabs切换形式
    handleClick (tab, event) {
      // console.log(tab)
      if (tab.label === '岗位发放系数') {
        // 岗位发放系数
        this.$refs.positionCoefficientRef.resetSearchList()
        this.$refs.positionCoefficientRef.getData()
      } else if (tab.label === '岗位KPI达成统计') {
        // 岗位KPI达成统计
        this.$refs.positionKpiAchRef.resetSearchList()
        this.$refs.positionKpiAchRef.getData()
      } else if (tab.label === '岗位计划系数与发放系数对比') {
        // 岗位计划系数与发放系数对比
        this.$refs.positionCoefficientComparisonRef.resetSearchList()
        this.$refs.positionCoefficientComparisonRef.getData()
      } else if (tab.label === '岗位达成与发放') {
        // 岗位达成与发放
        this.$refs.positionAchRef.resetSearchList()
        this.$refs.positionAchRef.getData()
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
